<template>
	<div>
		<basic-container>
			<div style="min-height: calc(100vh - 180px); background: #fff">
				<el-row :gutter="20">
					<template v-for="(item, index) in boxs">
						<el-col :span="6" v-if="permissions[item.permissions]" :key="index">
							<el-card class="box-card">
								<div>
									<div style="display: flex; align-items: center">
										<i :class="item.icon" style="font-size: 40px; color: #409eff"></i>
										<div style="display: flex; flex-direction: column; margin-left: 8px">
											<span style="color: #409eff; font-weight: bold">{{ item.name }}</span>
											<el-divider></el-divider>
											<span>{{ item.remark }}</span>
										</div>
									</div>
									<div style="width: 100%; display: flex; justify-content: center; margin-top: 12px">
										<el-button type="primary" style="width: 200px" @click="route(item.url)">进入</el-button>
									</div>
								</div>
							</el-card>
						</el-col>
					</template>
				</el-row>
			</div>
		</basic-container>
	</div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
	name: 'toolbox',
	components: {},
	data() {
		return {
			boxs: [
				{
					name: '可保地区查询',
					remark: '根据被保企业/被保人所在地区，查询可承保的保险产品',
					icon: 'el-icon-location-information',
					url: '/insurance/policy/workVerification/bannedAreaQuery',
					permissions: 'toolbox_area_query',
				},
				{
					name: '职业查询',
					remark: '通过输入职业名称，快速查询承保该职业的保险产品',
					icon: 'el-icon-s-custom',
					url: '/insurance/policy/workVerification/gzhc',
					permissions: 'toolbox_gzhc_query',
				},
				{
					name: '核保查询',
					remark: '通过回答核保问题，查询承保相关职业类别的保险产品',
					icon: 'el-icon-search',
					url: '/insurance/policy/workVerification/index',
					permissions: 'toolbox_work_query',
				},
			],
		}
	},
	created() {},
	computed: {
		...mapGetters(['permissions']),
	},

	methods: {
		route(url) {
			this.$router.push({path: url})
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-divider {
	margin: 8px 0 !important;
}
</style>
